// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimeUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { DATE_TIME_FORMAT } from 'logic/data/Izenda.TimeFormatConstants';
import uiState from 'logic/Izenda.UiState';
import { get, filter, isNil, includes, getOr } from 'lodash/fp';
import moment from 'moment';
import AppGlobal from 'Izenda.AppGlobal';

export default {
  TimeZoneOffset: {
    // pattern for check when typing offset in input
    onChangePattern: /^(\+|\-)?((1[0-2])|0?[0-9])?$/,
    // pattern for check when finish typing, need to have number
    finishedPattern: /^(\+|\-)?((1[0-2])|0?[0-9])$/,
    // check value match with typing pattern
    checkTimeZoneFormatOnTyping: function(value) {
      return this.onChangePattern.test(value);
    },
    // check value match with finished pattern
    checkTimeZoneFormat: function(value) {
      return this.finishedPattern.test(value);
    },
    // format number to have plus sign if possitive
    formatTimeZone: function(value) {
      const prefix = value > 0 ? '+' : '';
      return prefix + value;
    }
  },

  /**
   * Get list of support date
   * @param {any} format date time format
   */
  filterDateTimeFormat: filter(function(format: any) {
    const listSupportedDateSetting = get('FOR_DATE_SETTING', DATE_TIME_FORMAT[format.name]);
    return isNil(listSupportedDateSetting) || includes(uiState.currentUser.dateFormat, listSupportedDateSetting);
  }),

  /**
   * compare date string Format
   * @param {any} str1 first date string
   * @param {any} str2 second date string
   */
  compareDateStringFormat: function(str1: any, str2: any) {
    const date1 = new Date(str1);
    const date2 = new Date(str2);

    return date1.getTime() > date2.getTime();
  },

  /**
   * Get current date time base on UTC time and time stamp offset
   */
  getUtcTimeWithTimestampOffset: function() {
    let currentDate = moment.utc();
    const defaultTimestampOffset = getOr(0, 'advancedSettings.other.timezoneForTimestampOffsetValue', AppGlobal);
    const userTimestampOffset = get('currentUser.timestampOffset', uiState);
    const timestampOffset = !isNil(userTimestampOffset) ? userTimestampOffset : defaultTimestampOffset;
    currentDate.add(timestampOffset, 'hours');
    return currentDate;
  }
};



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.DateTimeUtils.js